import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService } from '@core/services/authentication.serivce';
import { BaseDetailForm } from '@shared/ui/base-detail-form';
import { AuthUser } from '@shared/interfaces/entities/auth-user.interface';
import { UiGroupControl } from '@shared/ui/controls/ui-group-control.model';
import { TextControl } from '@shared/ui/controls/text-control.model';
import { ToggleControl } from '@shared/ui/controls/toggle-control.model';
import { ViewControl } from '@shared/ui/controls/view-control.model';
import { ViewRowControl } from '@shared/ui/controls/view-row-control.model';
import { OrganizationSelect } from '../../../shared/ui/select-controls/organizations-select.model';
import { UploadControl } from '../../../shared/ui/controls/upload-control.model';
import { ToolbarItem } from '../../../shared/interfaces/tool-bar-item.interface';
import { faPlus, faRemove, faSearch } from '@fortawesome/free-solid-svg-icons';
import { DetailService } from '../../../core/services/detail.service';
import { UiColumn } from '../../../shared/ui/ui-column';
import { TabOptions } from '../../../shared/interfaces/tab-option.interface';
import { TabControl } from '../../../shared/ui/controls/tab-control.model';
import { SelectEvent, FileInfo, RemoveEvent, UploadComponent } from '@progress/kendo-angular-upload';
import { Bundle } from '../../../shared/interfaces/entities/bundle.interface';
import { FormControl } from '@angular/forms';
import { throwError } from 'rxjs';
import { INotificationService } from '../../../shared/services/inotification.service';
import { ReadOnlyIf, RequiredIf } from '../../../shared/ui/control-options/control-option.interface';
import { Permission } from '../../../core/literals/permission.literal';
import { BundleService } from '../services/bundle.service';
import { CartService } from '../../../shared/services/cart.service';
import { EditorControl } from '../../../shared/ui/controls/editor-control.model';
import { TextAreaControl } from '../../../shared/ui/controls/textarea-control.model';
import { CountrySelect } from '../../../shared/ui/select-controls/country-select.model';
import { CountryFilter } from '../../../shared/interfaces/select-filters/country-filter.interface';
export interface IFile extends FileInfo {
  image: string;
}

@Component({
    selector: 'app-bundle',
    templateUrl: './bundle.component.html',
    styleUrls: ['./bundle.component.css'],
    standalone: false
})

export class BundleComponent extends BaseDetailForm<Bundle> {

  @ViewChild('kendoUpload') kendoUpload: UploadComponent;
  @Output() submitRequest: EventEmitter<Array<IFile>> = new EventEmitter();

  organizationId: number;
  isAdmin: boolean;

  canUpdateBundles: boolean;

  id: string;

  public width = "30%";
  public height = "300px";

  constructor(private activatedRoute: ActivatedRoute,
    private auth: AuthenticationService,
    private detailService: DetailService<any>,
    private router: Router,
    private notificationService: INotificationService,
    private bundleService: BundleService,
    private cartService: CartService) {
    super();
    this.name = "Bundle";
    this.apiController = "Bundle";
    this.keyFieldName = "id";

    this.activatedRoute.params.subscribe(params => this.id = params['id']);

    this.initializeUiControls();
  }


  ngOnInit() {
    var session = this.auth.getSession();

    this.canUpdateBundles = (this.auth.canPerformAction(Permission.CreateUpdateBundles));

  }

  public removeCollection() {
    //This is the bundle organization ID
    this.detailService.remove(this.id, "Bundle");
  }

  preSave(formControls: { [k: string]: FormControl }): void {

    var organizationid = this.auth.getOrganizationId();

    formControls['organizationid'] = new FormControl(organizationid);
  }

  entityLoaded(): void {
    if (this.entity) {
      var session = this.auth.getSession();
      this.organizationId = this.auth.getOrganizationId();
      this.isAdmin = this.auth.isAdmin();

      //check if this record matches the current organizationId
      if (this.entity.organizationId != session?.organizationId) {
        throwError(() => new Error('You are not allowed to view this due to organization'));

        this.router.navigate(['']);
        this.notificationService.show({ title: "Error!", type: "error", description: "You are not allowed to view this due to organization" });
      }

      var addBundleToCartBtn: ToolbarItem = {
        text: 'Add to Cart',
        icon: faPlus,
        cssClass: 'success',
        hasMultiple: false,
        action: () => { this.addBundleToCart(); }
      };

      var items = this.toolbarItems;
      this.toolbarItems = [];
      for (var i = 0; i < items.length; i++) {
        this.toolbarItems.push(items[i]);
      }
      if (this.entity.isInStock) {
        this.toolbarItems.push(addBundleToCartBtn)
      }
    }
  }

  public addBundleToCart() {
    this.bundleService.addBundleToCart(Number(this.id)).subscribe((data => {
      if (data.wasSuccessful) {
        this.bundleService.overlayService.close();

        //refresh the cart data
        this.cartService.setRefresh(true);

        //after it's added, open up the cart window
        var wrapper = document.getElementsByClassName('wrapper')[0];
        wrapper.classList.toggle('opened');

        if (wrapper.className.includes("opened")) {
          //add overlay
          document.getElementById('cartOverlay')?.classList.add('k-overlay');
        }

      } else {
     /*   this.feedback.give({ text: "Error! " + data.message, status: "error" });*/
      }
    }));
  }


  override initializeUiControls() {

    var canAddUpdateItemBundles = this.auth.canPerformAction(Permission.CreateUpdateBundles);

    const detailsView = new ViewControl("Bundle Details");

    const userDetails = new UiGroupControl("", "Bundle Details");

    const name = new TextControl("name", "Name", "");
    name.addOption(new ReadOnlyIf(() => {
      return !canAddUpdateItemBundles;
    }));

    name.addOption(new RequiredIf(() => {
      return true;
    }));

    const description = new EditorControl("description", "Description", "", false);
    description.addOption(new ReadOnlyIf(() => {
      return !canAddUpdateItemBundles;
    }));

    const country = new CountrySelect("countryId", "Country", null);
    country.addOption(new ReadOnlyIf(() => {
      return !canAddUpdateItemBundles || this.id != "0";
    }));

    var countryFilter: CountryFilter = {
      organizationId: this.auth.getOrganizationId()
    };

    country.filters = countryFilter;

    country.addOption(new RequiredIf(() => {
      return true;
    }));

    const isInStock = new ToggleControl("isInStock", "Is Bundle In Stock?", null);
    isInStock.addOption(new ReadOnlyIf(() => {
      return true;
    }));

    const disabled = new ToggleControl("isActive", "Is Active?", null);
    disabled.addOption(new ReadOnlyIf(() => {
      return !canAddUpdateItemBundles;
    }));

    var uRow1 = new ViewRowControl();
    uRow1.controls.push(name, description);

    var uRow2 = new ViewRowControl();
    uRow2.controls.push(country, isInStock);

    var uRow3 = new ViewRowControl();
    uRow3.controls.push(disabled);

    userDetails.rows.push(uRow1, uRow2, uRow3);
    detailsView.controls.push(userDetails);


    var itemBundleColumns: UiColumn[] = [
      new UiColumn("item_Name", "SKU", 300),
      new UiColumn("item_Title", "Title", 300),
      new UiColumn("item_Quantity", "Item Stock", 200),
      new UiColumn("quantity", "Bundle Quantity", 200)
    ];

    var itemBundles: TabOptions = {
      name: "itemBundles",
      label: "Item Bundles",
      columns: itemBundleColumns,
      apiController: "ItemBundle",
      showDeleteBtn: canAddUpdateItemBundles,
      showEditBtn: canAddUpdateItemBundles,
      showAddBtn: canAddUpdateItemBundles,
      editWindowSettings:
      {
        width: 600,
        height: 250
      }
    };

    const itemBundlesTab = new TabControl(itemBundles);
 

    //If this is a new Collection - hide the partial view, we can only add a collection organization IF there is a collection saved
    if (Number(this.id) != 0) {
      detailsView.controls.push(itemBundlesTab);
    }

    this.views.push(detailsView);

    var session = this.auth.getSession();
    var canEditSettings: boolean = false;
    if (session) {
      canEditSettings = session.userId.toString() == this.id;
    }
  }
}


